export default {
  postCheck: false,
  checkAlert: 0,
  successMessage: null,
  warningMessage: null,
  infoMessage: null,
  dangerMessage: null,

  loadingCheck: 0,
  loadingMessage: "در حال انجام عملیات",

  loadingBtn: false,
  loadBtn: false,

  searchList: [],
};
